<script>
    import {slide} from 'svelte/transition';
    import {createEventDispatcher} from "svelte";
    import app from "../lib/stores/app.js";
    import {ROUTE_TYPE} from "../lib/js/constants.js";
    import {copyObject, formatPrice} from "../lib/js/utils.js";

    export let offer;

    const dispatch = createEventDispatcher();

    let tours = [];
    let isOpen = false;

    async function toggleDetails() {
        if (isOpen) {
            isOpen = false;
            return;
        }

        isOpen = true;
    }

    function handleSelectVehicle(vehicle) {
        let obj = copyObject(offer);
        // set offer selected vehicle
        obj.vehicle = vehicle;
        dispatch("select", obj);
    }

    // set offer tours
    offer.routes.map(item => {
        if (item.route_type == ROUTE_TYPE.TOUR) {
            tours.push(item);
        }
    })
</script>

<div class="offer-card card border-0 shadow-sm mb-4 {offer.is_best === '1' ? 'best-offer' : ''}">
    {#if offer.is_best == 1}
        <span class="badge offer-badge">Best offer</span>
    {/if}

    <div class="card-body p-3 p-md-4">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-3 mb-3">
            <div>
                <div class="offer-name text-uppercase small fw-semibold text-muted mb-1">
                    {offer.name}
                </div>
                <h5 class="offer-title mb-0">
                    {offer.title}
                </h5>
                <div>
                    {offer.description}
                </div>
            </div>
        </div>

        <div class="vehicle-list mb-3">
            {#each offer.vehicles as vehicle, index}
                <div class="vehicle-item {index !== offer.vehicles.length - 1 ? 'with-border' : ''}">
                    <div class="row align-items-center g-3">
                        <div class="col-lg-7 col-md-6">
                            <div class="vehicle-content">
                                <div>
                                    <div class="vehicle-name fw-semibold mb-1">{vehicle.name}</div>
                                    <div class="vehicle-info text-muted">{vehicle.info}</div>
                                </div>
                                <div class="vehicle-image">
                                    <img src="/app/assets/images/vehicles/vehicle-{vehicle.id}.png" class="img-fluid"
                                         alt={vehicle.name}>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6 col-lg-2 col-md-3">
                            <div class="d-flex gap-2 align-items-center justify-content-center">
                                <div class="vehicle-start-price text-muted">
                                    <s>{formatPrice(vehicle.start_price)}</s>
                                </div>
                                <div class="vehicle-price fw-bold">
                                    {formatPrice(vehicle.price)}
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-3">
                            <button type="button" class="btn btn-dark w-100"
                                    on:click={() => handleSelectVehicle(vehicle)}>
                                Choose vehicle
                            </button>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
        <div class="included">
            <div class="title">
                Included with your service:
            </div>
            <div class="included-items">
                <div>✔ Private transfer</div>
                <div>✔ Meet & greet (arrival)</div>
                <div>✔ Flight monitoring</div>
                <div>✔ Complimentary water & Wi-Fi</div>
                <div>✔ 24/7 support</div>
            </div>
        </div>

        <div class="pt-3">
            <button type="button" class="btn btn-link offer-details-btn p-0" on:click={toggleDetails}
                    aria-expanded={isOpen}>
                {#if isOpen}
                    Hide offer details
                {:else}
                    View offer details
                {/if}
            </button>
        </div>

        {#if isOpen}
            <div class="offer-details mt-3 pt-3 border-top" transition:slide={{duration:100}}>
                <div class="small text-uppercase fw-semibold text-muted mb-2">
                    Offer details
                </div>

                <div class="details-text text-muted">
                    {@html offer.content}
                </div>

                {#if tours.length > 0}
                    <div class="small text-uppercase fw-semibold text-muted mt-4 mb-2">
                        Included tours
                    </div>
                    <div class="d-flex flex-column">
                        {#each tours as tour}
                            <div>
                                ›
                                <button class="btn btn-link text-start ps-1 py-1"
                                        on:click={() => $app.tour_id = tour.tour_id}>
                                    {tour.title}
                                </button>
                            </div>
                        {/each}
                    </div>
                {/if}
            </div>
        {/if}
    </div>
</div>

<style>
    .offer-card {
        position: relative;
        border-radius: 18px;
        background: #fff;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .offer-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.08) !important;
    }

    .best-offer {
        background: linear-gradient(180deg, #fffdf7 0%, #ffffff 100%);
        border: 1px solid rgba(255, 193, 7, 0.35) !important;
    }

    .offer-badge {
        position: absolute;
        top: 0;
        left: 20px;
        transform: translateY(-50%);
        background: #198754;
        color: #fff;
        border-radius: 999px;
        padding: 0.45rem 0.75rem;
        font-weight: 600;
        font-size: 0.75rem;
        letter-spacing: 0.02em;
    }

    .offer-name {
        letter-spacing: 0.06em;
    }

    .offer-title {
        font-size: 1.1rem;
        line-height: 1.4;
        font-weight: 700;
        color: #212529;
    }

    .offer-summary {
        min-width: 120px;
    }

    .vehicle-list {
        border: 1px solid #edf0f2;
        border-radius: 14px;
        overflow: hidden;
        background: #fcfcfd;
    }

    .vehicle-item {
        padding: 1rem;
    }

    .vehicle-item.with-border {
        border-bottom: 1px solid #edf0f2;
    }

    .vehicle-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .vehicle-name {
        font-size: 1rem;
        color: #212529;
    }

    .vehicle-info {
        font-size: 0.94rem;
        line-height: 1.2;
    }

    .vehicle-image {
        width: 100px;
        height: 50px;
    }

    .vehicle-meta-label {
        margin-bottom: 0.2rem;
    }

    .vehicle-meta-value {
        font-weight: 600;
        color: #212529;
    }

    .vehicle-start-price {
        font-size: 0.95rem;
        /*margin-bottom: 0.15rem;*/
    }

    .vehicle-price {
        font-size: 1.45rem;
        line-height: 1.1;
        color: #212529;
    }

    .offer-details-btn {
        text-decoration: none;
        font-weight: 600;
    }

    .offer-details-btn:hover {
        text-decoration: underline;
    }

    .offer-details {
        animation: fadeIn 0.2s ease;
    }

    .details-text {
        font-size: 0.95rem;
        /*line-height: 1.6;*/
        white-space: pre-line;
    }

    .included {

    }

    .included .title {

    }

    .included .included-items {
        display: flex;
        flex-wrap: wrap;
        column-gap: 15px;
        font-size: 13px;
        color: var(--bs-secondary-color) !important;
    }

    :global(.details-text p) {
        margin: 0;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 576px) {
        .vehicle-content {
            display: block;
            text-align: center;
        }

        .vehicle-image {
            width: 90px;
            height: auto;
            margin: 10px auto auto auto;
        }
    }

    @media (max-width: 991.98px) {
        .vehicle-price {
            font-size: 1.3rem;
        }
    }

    @media (max-width: 767.98px) {
        .offer-card {
            border-radius: 16px;
        }

        .vehicle-item {
            padding: 0.9rem;
        }

        .vehicle-price {
            /*margin-top: 0.25rem;*/
        }
    }
</style>